export const masks = {
  phone: (value: string) => {
    return value
      .replace(/\D/g, '')
      .replace(/^(\d{2})(\d)/, '($1) $2')
      .replace(/(\d{5})(\d)/, '$1-$2')
      .replace(/(-\d{4})\d+?$/, '$1');
  },

  cpf: (value: string) => {
  const digits = value.replace(/\D/g, '').slice(0, 11);
  return digits
    .replace(/(\d{3})(\d)/, '$1.$2')
    .replace(/(\d{3})(\d)/, '$1.$2')
    .replace(/(\d{3})(\d{1,2})$/, '$1-$2');
},

  money: (value: string) => {
    const onlyNumbers = value.replace(/\D/g, '');
    const number = Number(onlyNumbers) / 100;

    if (Number.isNaN(number)) return '';

    return number.toLocaleString('pt-BR', {
      style: 'currency',
      currency: 'BRL'
    });
  }
};